import {createSlice} from '@reduxjs/toolkit'

export const uuidSlice = createSlice({
    name: 'uuid',
    initialState: {
        uuid: null,
    },
    reducers: {
        setUuid: (state, action) => {
            state.uuid = action.payload
        },
    },
})

export const { setUuid } = uuidSlice.actions
export default uuidSlice.reducer
